import { NoticeBar } from "common/styleguide/NoticeBar";
import { urls } from "lib/urls";
import _ from "lodash";
import React, { Fragment } from "react";
import ReactDOM from "react-dom";
import { FormattedMessage as T } from "react-intl";

export class LiveLogStatusBar extends React.PureComponent {
  constructor(props) {
    super(props);
    this._throttledResize = _.throttle(this.onResize, 300, { trailing: true });
  }

  componentDidMount() {
    const { liveLog, monitorResize } = this.props;
    if (liveLog.finalized && monitorResize) {
      this.onResize();
      window.addEventListener("resize", this._throttledResize);
    }
  }

  componentWillUnmount() {
    if (this.props.monitorResize) {
      window.removeEventListener("resize", this._throttledResize);
    }
  }

  // because the ll status bar can wrap -> has indeterminite height before render,
  // we need the ability to measure the clientHeight of this component and update
  // LiveLogPage with our height so we can know how much `top` to add to
  // FullscreenButton (which is positioned absolutely)
  // i consider this whole mess a big dumb HACK
  onResize = () => {
    const { liveLog, monitorResize, updateSBHeight } = this.props;

    if (liveLog.finalized && monitorResize && updateSBHeight) {
      updateSBHeight(ReactDOM.findDOMNode(this._ref).clientHeight);
    }
  };

  render() {
    const { user, liveLog, completed, unstarted, onRequestClose } = this.props;

    if (!liveLog.finalized) {
      return null;
    }

    return (
      <NoticeBar
        ref={(r) => {
          this._ref = r;
        }}
        onRequestClose={onRequestClose}
      >
        {completed && (
          <Fragment>
            <T
              id="llStatusBar.completed"
              defaultMessage="{name} has completed this ride. <a>View the complete ride here.</a>"
              values={{
                name: user.name,
                a: (...c) => <a href={urls.trips.show(liveLog.tripId)}>{c}</a>,
              }}
            />
          </Fragment>
        )}
        {unstarted && (
          <Fragment>
            <T
              id="llStatusBar.notCurrently"
              defaultMessage="{name} is not currently Live Logging. This page will begin updating as soon as a ride starts."
              values={{ name: user.name }}
            />
          </Fragment>
        )}
      </NoticeBar>
    );
  }
}
